<template>
  <div class="teacher-card">
    <!-- 咨询师 -->
    <div
      class="card-box"
      v-if="teacherInfo.consultTeacher"
      @click="linkToUserIndex"
    >
      <div class="card">
        <div class="teacher-info">
          <div class="avatar">
            <img :src="teacher.avatar | imgZip(200)" alt="" />
          </div>
          <div class="info">
            <div class="info-top">
              <div class="name">{{ nameFilter(teacher.realName) }}</div>
              <div class="ids">
                <div class="id-item no-bg" v-if="teacher.icon">
                  <img :src="teacher.icon" alt="" class="teacher-icon" />
                </div>
                <div class="id-item qs" v-if="isZixun">
                  <img src="~images/article/icon-baozhang.png" alt="" />
                  壹心理保障
                </div>
              </div>
            </div>
            <div class="info-bottom">
              <span v-if="teacher.zxNum"
                ><span class="num">{{ teacher.zxNum }}</span
                >人咨询</span
              >
              <span v-if="teacher.year"
                >· 从业<span class="num">{{ teacher.year }}</span
                >年</span
              >
            </div>
          </div>
        </div>
        <div class="teacher-tag">
          <div class="des" v-if="teacher.honor">{{ teacher.honor }}</div>
          <div class="tag" v-if="teacher.tags && teacher.tags.length">
            擅长领域：
            <span v-for="(tag, index) in teacher.tags" :key="index">
              {{ `${tag}${teacher.tags.length == index + 1 ? '' : '/'}` }}
            </span>
          </div>
        </div>
        <div class="zixun-btn">
          约ta咨询
          <span class="price" v-if="teacher.teacherPrice">{{
            `单次低至${teacher.teacherPrice}元/次`
          }}</span>
        </div>
      </div>
    </div>
    <!-- 倾诉师 -->
    <div
      class="card-box qingsu"
      v-if="teacherInfo.qingsuTeacher"
      @click="linkToIm"
    >
      <div class="card">
        <div class="teacher-info">
          <div class="avatar">
            <img :src="teacher.avatar | imgZip(200)" alt="" />
          </div>
          <div class="info">
            <div class="info-top">
              <div class="name">{{ nameFilter(teacher.realName) }}</div>
              <div class="ids">
                <div
                  class="id-item"
                  v-if="teacher.grade && teacher.grade.grade_name"
                >
                  <img src="~images/article/icon-qingsu.png" alt="" />
                  {{ teacher.grade.grade_name }}
                </div>
                <div class="id-item qs">
                  <img src="~images/article/icon-baozhang.png" alt="" />
                  壹心理保障
                </div>
              </div>
            </div>
            <div class="info-bottom">
              <span v-if="teacher.qingNum"
                ><span class="num">{{ teacher.qingNum }}</span
                >人倾诉</span
              >
              <!-- <span v-if="teacher.goodrate"
                >· 从业<span class="num">{{ teacher.goodrate }}</span
                >年</span
              > -->
              <span v-if="teacher.goodrate"
                >· 好评率<span class="num">{{ teacher.goodrate }}</span
                >%</span
              >
            </div>
          </div>
        </div>
        <div class="teacher-tag">
          <div class="des">{{ teacher.introduction }}</div>
          <div class="tag" v-if="teacher.categorys && teacher.categorys.length">
            擅长领域：
            <span v-for="(tag, index) in teacher.categorys" :key="index">
              {{ `${tag}${teacher.categorys.length == index + 1 ? '' : '/'}` }}
            </span>
          </div>
        </div>
        <button class="qingsu-btn">去倾诉</button>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    teacherInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['isLogin', 'loginUser']),
    teacher() {
      return (
        this.teacherInfo?.consultTeacher ||
        this.teacherInfo?.qingsuTeacher ||
        {}
      )
    },
    isZixun() {
      return this.teacherInfo?.consultTeacher
    }
  },
  mounted() {},
  methods: {
    linkToUserIndex() {
      let id = this.teacher?.userId
      if (!this.teacher?.userId) return
      this.$emit('seeCard')
      this.routerPush(
        `${this.$const.userPage}${id}?_source_page_=问答详情&channle_flag=Platform_content_QA`
      )
    },
    linkToIm() {
      if (!this.isLogin) return this.toLogin()
      let id = this.teacher?.userId
      const queryStr = qs.stringify({
        user_id: id,
        node: 1,
        channel_flag: 'Platform_content_QA'
      })
      const { isYixinliApp, isZiXunApp } = this.$platform
      if (isYixinliApp || isZiXunApp) {
        window.location.href = `yixinli://open_chat?${queryStr}`
      } else {
        this.routerPushWithoutNav({
          path: `/homepage/${id}`,
          query: {
            id,
            fromQingSuPage: 1,
            channel_flag: 'Platform_content_QA'
          }
        })
      }
    },
    nameFilter(val) {
      if (!val) return ''
      if (val.length > 3) return val.substring(0, 3) + '...'
      return val
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-card {
  background: #fff;
  padding-bottom: 40px;
  .card-box {
    display: flex;
    width: 686px;
    padding: 58px 60px;
    margin: 0 auto;
    background: url('~images/qa/anwser/zx-bg.png') no-repeat center/100% 100%;
    box-sizing: border-box;
    .card {
      position: relative;
    }
    .teacher-info {
      display: flex;
      .avatar {
        width: 100px;
        height: 100px;
        > img {
          width: 100px;
          height: 100px;
          border-radius: 16px;
          object-fit: cover;
        }
      }
      .info {
        margin-left: 16px;
      }
      .info-top {
        display: flex;
        align-items: center;
        .name {
          max-width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 32px;
          line-height: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #21252d;
        }
      }
      .ids {
        display: flex;
        align-items: center;
        .id-item {
          display: flex;
          align-items: center;
          height: 36px;
          padding: 0 12px 0 4px;
          margin-left: 10px;
          background: #fcf0dc linear-gradient(180deg, #fef5e6 0%, #f5e6b2 100%);
          border-radius: 10px;
          font-size: 20px;
          font-weight: 600;
          color: #a2762e;
          white-space: nowrap;
          > img {
            width: 30px;
            height: 30px;
            margin-right: 5px;
            &.teacher-icon {
              width: 158px;
              height: 36px;
            }
          }
          &.qs {
            background: #eef1ff;
            color: #6466bb;
          }
          &.no-bg {
            background: none;
            padding: 0;
          }
        }
      }
      .info-bottom {
        margin-top: 18px;
        font-size: 24px;
        font-weight: 400;
        color: #434c5c;
        .num {
          font-weight: 600;
          color: #21252d;
        }
      }
    }
    .introduction {
      max-width: 560px;
      line-height: 24px;
      font-size: 24px;
      font-weight: 400;
      color: #434c5c;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 20px;
    }
    .teacher-tag {
      margin-top: 20px;
      .des {
        font-size: 24px;
        font-weight: 400;
        color: #6c798c;
        width: 560px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .tag {
        color: #6c798c;
        border-radius: 6px;
        line-height: 1;
        margin-top: 20px;
        width: 560px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .zixun-btn {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 570px;
      height: 86px;
      margin-top: 50px;
      background: linear-gradient(180deg, #bdc9fd 0%, #6982fa 100%);
      border-radius: 48px;
      font-size: 32px;
      font-weight: 600;
      color: #ffffff;
      .price {
        position: absolute;
        right: 30px;
        top: -24px;
        font-size: 18px;
        font-weight: 500;
        color: #ffa202;
        padding: 6px 5px 8px 7px;
        background: url('~images/article/tips-bg.png') no-repeat center/100%
          100%;
      }
    }
  }
  .qingsu {
    position: relative;
    background: url('~images/qa/anwser/qingsu-bg.png') no-repeat center/100%
      100%;
    .teacher-info {
      .ids {
        .id-item {
          background: #ffefc9;
          color: #b78013;
          &.qs {
            background: #eef1ff;
            border-radius: 10px;
            color: #6466bb;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
          }
        }
      }
    }
    .qingsu-btn {
      width: 570px;
      height: 86px;
      background: linear-gradient(180deg, #feb6a9 0%, #fc7052 100%);
      border-radius: 48px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 32px;
      margin-top: 50px;
    }
  }
}
</style>
